import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';

// ====== Import schemas from generated ======
const {
  LoyaltySettingsFirestoreResponse,
  CreateLoyaltySettingsDto,
  UpdateLoyaltySettingsDto,
  DeleteLoyaltySettingsResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const LoyaltySettingsResponseSchema = LoyaltySettingsFirestoreResponse;
export const CreateLoyaltySettingsSchema = CreateLoyaltySettingsDto;
export const UpdateLoyaltySettingsSchema = UpdateLoyaltySettingsDto;

// ====== Type Exports ======
export type LoyaltySettingsResponse = z.infer<typeof LoyaltySettingsFirestoreResponse>;
export type CreateLoyaltySettings = z.infer<typeof CreateLoyaltySettingsDto>;
export type UpdateLoyaltySettings = z.infer<typeof UpdateLoyaltySettingsDto>;

// API factory function
export function createLoyaltySettingsApi(client: TypedApiClient) {
  return {
    getLoyaltySettings: (): Promise<LoyaltySettingsResponse> => {
      return client.get('/loyalty-settings', {
        responseSchema: LoyaltySettingsFirestoreResponse,
      });
    },

    createLoyaltySettings: (data: CreateLoyaltySettings): Promise<LoyaltySettingsResponse> => {
      return client.post('/loyalty-settings', {
        data,
        requestSchema: CreateLoyaltySettingsDto,
        responseSchema: LoyaltySettingsFirestoreResponse,
      });
    },

    updateLoyaltySettings: (data: UpdateLoyaltySettings): Promise<LoyaltySettingsResponse> => {
      return client.patch('/loyalty-settings', {
        data,
        requestSchema: UpdateLoyaltySettingsDto,
        responseSchema: LoyaltySettingsFirestoreResponse,
      });
    },

    deleteLoyaltySettings: (): Promise<z.infer<typeof DeleteLoyaltySettingsResponseDto>> => {
      return client.delete('/loyalty-settings', {
        responseSchema: DeleteLoyaltySettingsResponseDto,
      });
    },
  };
}
